const RTL_REGEX = /[\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0780-\u07BF\u0860-\u086F\u08A0-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF]/;

/**
 * Returns "rtl" if the majority of alphabetic characters in the text
 * belong to RTL scripts (Hebrew, Arabic, Syriac, Thaana, etc.), otherwise "ltr".
 * Falls back to "auto" for empty / whitespace-only strings.
 */
export function detectTextDirection(text: string | undefined | null): 'rtl' | 'ltr' | 'auto' {
  if (!text) return 'auto';

  let rtlCount = 0;
  let ltrCount = 0;

  for (const char of text) {
    if (RTL_REGEX.test(char)) {
      rtlCount++;
    } else if (/[A-Za-z]/.test(char)) {
      ltrCount++;
    }
  }

  if (rtlCount === 0 && ltrCount === 0) return 'auto';
  return rtlCount > ltrCount ? 'rtl' : 'ltr';
}
